$(document).on('change', '#select_franchisor', function () {
  $('.specialday-form').submit()
})

// Cloning a suggestion runs synchronously over a remote:true request that can
// take 30-60s (media + associated records are copied). Without a notice the user
// gets no feedback. Hook into rails-ujs ajax:send so the toast only appears once
// the request actually starts. The admin layout ships no JS toast helper, so we
// build a Bootstrap toast here matching the markup in admin_partials/_alerts.
$(document).on('ajax:send', '.js-clone-special-day', function () {
  const container = $('.toast-container-cloning').length
    ? $('.toast-container-cloning')
    : $('<div class="toast-container-cloning position-fixed top-0 end-0 p-5" style="z-index:100;"></div>').appendTo('body')

  const $toast = $(`
    <div class="toast fade" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="me-auto text-success">Duplication en cours</strong>

        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>

      <div class="toast-body">
        La duplication a démarré. Cela peut prendre 30 à 60 secondes pour se terminer complètement.
      </div>
    </div>
  `).appendTo(container)

  const toast = new window.bootstrap.Toast($toast[0], { autohide: true, delay: 60000 })
  toast.show()

  $toast.on('hidden.bs.toast', function () {
    $toast.remove()
  })
})

$(document).on('change', '.special-day-bulk-checkbox', function () {
  $('.special-day-bulk-action').prop('disabled', $('.special-day-bulk-checkbox:checked').length === 0)
})

$(document).on('turbolinks:load', function () {  
  // Select the franchisor and categories dropdown elements
  const $franchisorSelect = $('#franchisor_select');
  const $categoriesSelect = $('#categories_select');

  // Add change event listener to franchisor select
  $franchisorSelect.on('change', function() {
    const franchisorId = $(this).val();
    if (franchisorId) {
      // If a franchisor is selected, fetch its categories
      $.ajax({
        url: '/admin/special_days/load_franchisor_categories',
        data: { franchisor_ids: [franchisorId] },
        dataType: 'json',
        success: function(data) {
          // Clear existing options and add default option
          $categoriesSelect.empty().append('<option value="">Toutes les catégories</option>');
          
          // Add new category options based on the selected franchisor
          $.each(Object.values(data)[0], function(index, category) {
            $categoriesSelect.append($('<option>', {
              value: category.id,
              text: category.name
            }));
          });
          
          // Enable the categories select
          $categoriesSelect.prop('disabled', false);
        }
      });
    } else {
      // If no franchisor is selected, reset and disable the categories select
      $categoriesSelect.empty().append('<option value="">Toutes les catégories</option>');
      $categoriesSelect.prop('disabled', true);
    }
  });
});